import { Component, inject, input } from '@angular/core';
import { OnyxIconRegistryService } from '../../../internal/services/onyx-icon-registry.service';
import type { OnyxIconName } from '../interfaces';
import { OnyxCustomIconComponent } from '../onyx-custom-icon/onyx-custom-icon.component';

@Component({
  selector: 'onyx-icon',
  imports: [OnyxCustomIconComponent],
  templateUrl: './onyx-icon.component.html',
  styleUrl: './onyx-icon.component.scss',
})
export class OnyxIconComponent {
  private readonly _iconRegistryService = inject(OnyxIconRegistryService);

  public readonly name = input.required<OnyxIconName>();
  public readonly size = input.required<number>();
  public readonly frame = input<number>();
}
